<template>
  <div class="member-item">
    <div class="name">
      <div class="avatar">
        <div class="avatar-img">
          <img :src="player.hero_avatar" @error="playerImgError" alt="" />
        </div>
        <div class="level">{{ player.hero_level }}</div>
      </div>
      <div>
        <p>{{ player.player_name }}</p>
        <p>{{ player.hero_name }}</p>
      </div>
    </div>
    <div class="kda">
      <div> {{ player.kda | keepOneDecimalStr }}</div>
      <div>{{ `${player.kill_count}/${player.death_count}/${player.assist_count}` }}</div>
    </div>
    <div class="offered-rate">
      <el-progress type="circle" :width="46" :color="'#6da7fb'" :format="(val) => (val) + '%'" :percentage="offeredRate"></el-progress>
    </div>
    <div class="hit-count">
      {{ player.last_hits }}/{{ player.denies }}
    </div>
    <div class="money">
      {{ player.money }}
    </div>
    <div class="damage-count">
      {{ player.xpm }}
    </div>
    <div class="damage-taken-count">
      {{ player.gpm }}
    </div>
    <div class="prod">
      <div class="prop-list">
        <div v-for="(item, idx) in player.prop" :key="idx" class="prop-img-wrap">
          <img :src="item.img" alt="">
        </div>
        <div v-for="(item, idx) in 6" class="prop-img-wrap" :key="`default-${idx}`">
          <img src="../../../assets/images/gaming/dota-prop-default.png" alt="">
        </div>
      </div>
    </div>
    <div class="rune">
      <el-popover
        popper-class="rune-data-popover"
        placement="left-start"
        :visible-arrow="false"
        width="390"
        v-model="show"
        trigger="hover">
        <div class="rune-data-wrap">
          <p class="title">天赋树</p>
          <div class="rune-list" v-if="player.rune_list.length > 0">
            <div class="rune-level">
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[6].rune_id || -1) }">{{ player.rune_list[6].name || '' }}</div>
              <div class="level">25</div>
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[7].rune_id || -1) }">{{ player.rune_list[7].name || '' }}</div>
            </div>
            <div class="rune-level">
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[4].rune_id || -1) }">{{ player.rune_list[4].name || '' }}</div>
              <div class="level">20</div>
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[5].rune_id || -1) }">{{ player.rune_list[5].name || '' }}</div>
            </div>
            <div class="rune-level">
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[2].rune_id || -1) }">{{ player.rune_list[2].name || '' }}</div>
              <div class="level">15</div>
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[3].rune_id || -1) }">{{ player.rune_list[3].name || '' }}</div>
            </div>
            <div class="rune-level">
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[0].rune_id || -1) }">{{ player.rune_list[0].name || '' }}</div>
              <div class="level">10</div>
              <div class="rune-item" :class="{ 'active':  activeRune.includes(player.rune_list[1].rune_id || -1) }">{{ player.rune_list[1].name || '' }}</div>
            </div>
          </div>
        </div>
        <img class="rune-img" src="../../../assets/images/gaming/rune-icon.png" slot="reference" />
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DotaMemberItem',
  props: {
    player: {
      type: Object
    },
    coverInfo: {
      type: Object
    }
  },
  data () {
    return {
      show: false
    }
  },
  filters: {
    keepOneDecimalStr (num) {
      const result = Number(num.toString().match(/^\d+(?:\.\d{0,1})?/));
      let s = result.toString();
      let rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 1) {
        s += '0';
      }
      return s;
    }
  },
  computed: {
    offeredRate () {
      const rate = parseInt((this.player.offered_rate - 0) * 100)
      return rate < 0 ? 0 : rate
    },
    propLength () {
      return this.player.prop && this.player.prop.length
    },
    rune10 () {
      return this.player.rune_list.filter(player => {
        return player.num == '1' || player.num == '2'
      })
    },
    rune15 () {
      return this.player.rune_list.filter(player => {
        return player.num == '3' || player.num == '4'
      })
    },
    rune20 () {
      return this.player.rune_list.filter(player => {
        return player.num == '5' || player.num == '6'
      })
    },
    rune25 () {
      return this.player.rune_list.filter(player => {
        return player.num == '7' || player.num == '8'
      })
    },
    activeRune () {
      return (this.player.rune || []).map(rune => {
        return rune.rune_id
      }) || []
    }
  }
}
</script>

<style lang="less" scoped>
.name {
  width: 176px;
  margin-right: 10px;
}
.kda {
  width: 92px;
}
.offered-rate {
  width: 64px;
  margin-right: 15px;
}
.hit-count {
  width: 67px;
  margin-right: 6px;
}
.money {
  width: 72px;
  margin-right: 6px;
}
.damage-count {
  width: 72px;
  margin-right: 6px;
}
.damage-taken-count {
  width: 72px;
  margin-right: 4px;
}
.prod {
  width: 240px;
}
.rune {
  width: 100px;
}
.member-item {
  display: flex;
  align-items: center;
  height: 80px;
  text-align: center;
  box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25);
  font-size: 14px;
  background: #fff;
  .name {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    padding-left: 18px;
    .avatar {
      position: relative;
      width: 50px;
      height: 50px;
      border-radius: 4px;
      display: flex;
      overflow: hidden;
      justify-content: center;
      background-image: url('../../../assets/images/gaming/pick-hero-border.png');
      background-repeat: no-repeat;
      background-size: 100%;
      padding: 2px;
      border-radius: 9px;
      overflow: hidden;
      .avatar-img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 9px;
      }
      img {
        height: 100%;
        display: block;
      }
      .level {
        position: absolute;
        bottom: 2px;
        left: 2px;
        height: 17px;
        font-size: 12px;
        text-align: center;
        width: 17px;
        line-height: 17px;
        background: rgba(0,0,0,0.55);
        border-radius: 0px 0 0px 9px;
        color: #fff;
      }
    }
    p {
      font-size: 14px;
      width: 95px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 20px;
      &:last-child {
        color: #777777;
      }
    }
  }
  .kda {
    width: 92px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    div:last-child {
      color: #777;
    }
  }
  .offered-rate {
    width: 64px;
    margin-right: 15px;
    /deep/ svg{
      transform: rotateY(180deg);
    }
  }
  .hit-count {
    width: 67px;
    margin-right: 6px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    div:last-child {
      color: #777;
    }
  }
  .money {
    width: 72px;
    margin-right: 6px;
  }
  .damage-count {
    width: 72px;
    margin-right: 6px;
  }
  .damage-taken-count {
    width: 72px;
    margin-right: 4px;
  }
  .prod {
    display: flex;
    justify-content: center;
    .prop-list {
      display: flex;
      gap: 4px;
      padding-left: 12px;
      overflow: hidden;
      flex-wrap: wrap;
      width: 140px;
      height: 50px;
      overflow: hidden;
      .prop-img-wrap {
        width: 40px;
        height: 23px;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        overflow: hidden;
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .rune {
    .rune-img {
      width: 57px;
      height: 57px;
    }
  }
}
</style>


<style lang="less">
.rune-data-popover {
  padding: 0;
  background: transparent;
  border: none;
}
.rune-data-wrap {
  height: 300px;
  background-image: url('../../../assets/images/gaming/rune-bg.png');
  background-size: 390px 300px;
  .title {
    text-align: center;
    color: #BC9E37;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    font-weight: bold;
  }
  .rune-list {
    padding: 11px 17px;
    .rune-level {
      display: flex;
      height: 48px;
      margin-bottom: 7px;
      .level {
        width: 48px;
        height: 48px;
        font-size: 18px;
        color: #FFE18C;
        line-height: 48px;
        text-align: center;
      }
      .rune-item {
        flex: 1;
        text-align: center;
        color: #fff;
        align-items: center;
        display: flex;
        justify-content: center;
        font-size: 12px;
        line-height: 14px;
        padding: 0 4px;
        &.active {
          color: #FFE18C;
        }
      }
    }
  }
}
</style>
